import './App.css';
import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import CssBaseline from '@mui/material/CssBaseline';
import LayoutDashboard from "./layouts/LayoutDashboard";

import NotFound from "./pages/NotFound";
import Home from "./pages/Home";
import Login from "./pages/login";
import DsrcRawData from 'pages/components/dashboard/SearchDsrcData';
import VMSMonitoring from 'pages/components/dashboard/VmsMonitoring';
import BISFaultReport from 'pages/components/dashboard/BISFaultReport';

import DashboardHome from 'pages/DashboardHome';
import GisHome from 'pages/GisHome';
import ModuleHome from 'pages/ModuleHome';

import IntegratedControlViewD from 'pages/dashboard/IntegratedControlViewD';
import RoadTrafficViewD from 'pages/dashboard/RoadTrafficViewD';
import TrafficSafetyViewD from 'pages/dashboard/TrafficSafetyViewD';
import SignalOperationViewD from 'pages/dashboard/SignalOperationViewD';
import BusOperationViewD from 'pages/dashboard/BusOperationViewD';
import FutureTransportationViewD from 'pages/dashboard/FutureTransportationViewD';

import GisView from 'pages/gis/GisView';
import GisView2 from 'pages/gis/GisView2';

import IntegratedControlViewM from 'pages/module/IntegratedControlViewM';
import RoadTrafficViewM from 'pages/module/RoadTrafficViewM';
import TrafficSafetyViewM from 'pages/module/TrafficSafetyViewM';
import TrafficSafetyViewDetailM from 'pages/module/TrafficSafetyViewDetailM';
import SignalOperationViewTestM from 'pages/module/SignalOperationViewTestM';
import SignalOperationViewM from 'pages/module/SignalOperationViewM';
import BusOperationViewM from 'pages/module/BusOperationViewM';
import FutureTransportationViewM from 'pages/module/FutureTransportationViewM';

import { CommonThemeProvider } from 'utils/commonTheme';
import { settingsConfig } from 'utils/commonFunc';

import { DashboardProvider } from './pages/components/DashboardContext';

import { CctvProvider } from 'pages/sharedCamera';

import Link2SelectView from 'pages/Link2SelectView';

const PrivateRoute = ({ children }) => {
  const isAuth = localStorage.getItem('isAuthenticated') === 'true';
  return isAuth ? children : <Navigate to="/login" replace />;
};


function App() {
  return (
    <CommonThemeProvider>
      <DashboardProvider>
        <CctvProvider>
          <React.Fragment>
            <CssBaseline />
            <Routes>
              {window.serviceConfig.privateServiceMode === true &&
                <React.Fragment>
                  <Route path="/" element={<PrivateRoute><Home /></PrivateRoute>} />
                  <Route path="/login" element={<Login />} />
                  <Route path="/" elemnet={<Home />} />
                  <Route path="/dsrcData" element={<DsrcRawData />} />
                  <Route path="/vmsMonitoring" element={<VMSMonitoring />} />
                  <Route path="/BISFaultReport" element={<BISFaultReport />} />
                  {/* <Route index element={<Home />} /> */}
                  <Route path="/dashboard" element={<LayoutDashboard strech={settingsConfig().strechMode} />}>
                    <Route index element={<DashboardHome />} />
                    <Route path="/dashboard/integratedControlView" element={<IntegratedControlViewD />} />
                    <Route path="/dashboard/roadTrafficView" element={<RoadTrafficViewD />} />
                    <Route path="/dashboard/trafficSafetyView" element={<TrafficSafetyViewD />} />
                    <Route path="/dashboard/signalOperationView" element={<SignalOperationViewD />} />
                    <Route path="/dashboard/busOperationView" element={<BusOperationViewD />} />
                    <Route path="/dashboard/futureTransportationView" element={<FutureTransportationViewD />} />
                    <Route path="/dashboard/*" element={<NotFound />} />
                  </Route>

                  <Route path="/gis" element={<LayoutDashboard strech={settingsConfig().strechMode} />}>
                    <Route index element={<GisHome />} />
                    <Route path="/gis/gisView" element={<GisView />} />
                    <Route path="/gis/gisView2" element={<GisView2 />} />
                    <Route path="/gis/*" element={<NotFound />} />
                  </Route>

                  <Route path="/module" element={<LayoutDashboard strech={settingsConfig().strechMode} />}>
                    <Route index element={<ModuleHome />} />
                    <Route path="/module/integratedControlView" element={<IntegratedControlViewM />} />
                    <Route path="/module/roadTrafficView" element={<RoadTrafficViewM />} />
                    <Route path="/module/trafficSafetyView" element={<TrafficSafetyViewM />} />
                    <Route path="/module/trafficSafetyViewDetail" element={<TrafficSafetyViewDetailM />} />
                    <Route path="/module/signalOperationViewTest" element={<SignalOperationViewTestM />} />
                    <Route path="/module/signalOperationView" element={<SignalOperationViewM />} />
                    <Route path="/module/busOperationView" element={<BusOperationViewM />} />
                    <Route path="/module/futureTransportationView" element={<FutureTransportationViewM />} />
                    <Route path="/module/*" element={<NotFound />} />
                  </Route>

                  <Route
                    path="/Link2SelectView"
                    element={<LayoutDashboard strech={settingsConfig().strechMode} />}
                  >
                    <Route index element={<Link2SelectView />} />
                  </Route>

                </React.Fragment>
              }
              <Route path="*" element={<NotFound />} />
            </Routes>
          </React.Fragment>
        </CctvProvider>
      </DashboardProvider>
    </CommonThemeProvider>
  );
}

export default App;